import { useLocation } from "react-router-dom";
import QuotationsTable from "./QuotationsTable";

export const NotificationPageQuote = () => {
    const location = useLocation();
    return <QuotationsTable key={location.key} />
 }